export default "__VITE_ASSET__BDMGo1vV__"